import React, { useState, useEffect } from 'react';
import logo from '../../../assets/images/logo.png';

import rightArrowIcon from '../../../assets/images/right-arrow-icon.svg';

import './index.css';
import { Button, Col, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { FaPlay } from 'react-icons/fa';

// import axios from 'axios';
// import moment from 'moment';

import { useDispatch, useSelector } from 'react-redux';
// import { toast } from 'react-toastify';

// import { DEV_API, SPORTS_CATEGORY, URL, WIN_POINT_RULES } from '../../../const/index.js';
// import SideMenu from '../../../components/SideMenu.js';
// import { SPORT_ADD } from "../../../store/actionTypes.js";
// import PaginationComponent from '../../../components/layouts/paginate.js'

import Template from "../Template.js"
import VideoModal from '../../../components/videoModal/index.js';
import BallhogIntro from '../../../assets/video/BallhogIntro.mp4';
import Playformoney from '../../../assets/video/Playformoney.mp4';
import Playwithfriends from '../../../assets/video/Playwithfriends.mp4';

const VIDEO_LINKS = [
  {
    label: 'BallHog Intro',
    src: BallhogIntro
  },
  {
    label: 'Play For Money',
    src: Playformoney
  },
  {
    label: 'Play With Friends',
    src: Playwithfriends
  },
]

const HowToPlay = () => {
  // const dispatch = useDispatch();
  // const navigate = useNavigate();
  // const { user } = useSelector((state) => state.auth);

  // // const [team1Idx, setTeam1Idx] = useState(-1);
  // // const [sportCategory, setSportCategory] = useState('NFL');
  // // const [events, setEvents] = useState([]);
  // // const [playList, setPlayList] = useState({});

  // // const [selectedEvt, setSelectedEvt] = useState(null);
  // // const [event, setEvent] = useState([]);
  // // const [eventId, setEventId] = useState(-1);
  // // const [eventDate, setEventDate] = useState();

  // // const [primaryColor, setPrimaryColor] = useState('#0d6efd')
  // // const [secondaryColor, setSecondaryColor] = useState('white')

  // // const [totalItems, setTotalItems] = useState(1);
  // // const [page, setPage] = useState(1)

  const [source, setSource] = useState(BallhogIntro);
  const [isModalOpen, setModalOpen] = useState(false);

  return (
    <>
      <Template>
        <div className='screen-2-section'>
          <div className='screen-2-content'>
            <div className='screen-top-part'>
              <div className='logo-part'>
                <Link to="/">
                  <img src={logo} alt="logo" className='img-fluid' />
                </Link>
              </div>
              <span className='screen-title'>How To Play AI videos</span>
            </div>
            <div className='screen-2-centerpart'>
              {
                VIDEO_LINKS.map((item) => {
                  return (
                    <div className='pt-2'>
                      <Row>
                        <Col xs={1}></Col>
                        <Col xs={6}>
                          <div>
                            <p className='text-white border border-1 border-secondary p-1 rounded-3 text-center'>{item.label}</p>
                          </div>
                        </Col>
                        <Col xs={2}></Col>
                        <Col xs={3}><FaPlay className="mr-2 text-white" onClick={() => { setModalOpen(true); setSource(item.src) }} /></Col>
                      </Row>
                    </div>
                  )
                })
              }
              {/* <div className='d-flex justify-content-center'>
                <PaginationComponent
                  totalItems={totalItems}
                  itemsPerPage={5}
                  currentPage={page}
                  onPageChange={(number) => { setPage(number) }}
                />
              </div> */}
              <div className='screen-2-center-block'>
              </div>
            </div>

            <div className='screen-2-bottom-button'>
              {/* <Button onClick={() => handlePlayGame(1)}>
                <img src={moneywave} alt="moneywave" className='img-fluid' />
                Check Game
              </Button> */}
              {/* <Button onClick={() => handlePlayGame(2)}>Replay Game</Button> */}
            </div>
          </div>
        </div>
        <VideoModal
          isOpen={isModalOpen}
          onClose={() => setModalOpen(false)}
          videoSrc={source}
        />
      </Template>
    </>
  );
};

export default HowToPlay;
